import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse, ICmsJourneyPlannerResponse } from "../../Orchestrator/Types/Index";

export const getCmsJourneyPlanner = async (): Promise<IApiResponse<ICmsJourneyPlannerResponse>> => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsJourneyPlannerAPI;

  const params = new URLSearchParams({
    locale: await getLocaleFromCookie(),
    populate: "image",
  });

  return await cmsApiRequest<ICmsJourneyPlannerResponse>(`${endpoint}?${params.toString()}`, "GET");
};
